import {Component, OnDestroy, OnInit} from '@angular/core';

import {trigger, style, animate, transition} from '@angular/animations';
import {
  ActivityModel,
  BusinessModel,
  BusinessUnitModel,
  ContactModel,
  EActivityContentType,
  EContactType,
  VisitReportContentModel,
  EmptyActivityContentModel,
  TopicModel,
  InvoiceActivityContentModel,
  OrderActivityContentModel,
  ProjectModel,
  OrderConfirmationActivityContentModel,
  OfferContentModel,
  NoteContentModel,
  ActivityContentModel,
  UserModel,
  OnlineMeetingContentModel,
  TradeShowMeetingContentModel,
  OnSiteMeetingContentModel,
  ActivityStatusData,
  EActivityStatus,
  ProjectSummaryContentModel,
} from '../../@models';
import {ApiService} from '../../@core/service/api.service';
import {firstValueFrom, Observable, Subscription} from 'rxjs';
import {SidebarCommon} from '../../@core/common/sidebar';
import {NbDialogService, NbToastrService} from '@nebular/theme';
import {FormListProjectRendererComponent} from '../shared/form-list/renderer/form-list-project-renderer.component';
import {
  FormListBusinessUnitRendererComponent,
} from '../shared/form-list/renderer/form-list-business-unit-renderer.component';
import {FormListActionplanComponent} from '../shared/form-list/renderer/form-list-actionplan.component';
import {FormListActionplanEditComponent} from '../shared/form-list/renderer/form-list-actionplan-edit.component';
import {ActivatedRoute, Router} from '@angular/router';
import {FormListSortFieldRenderComponent} from '../shared/form-list/renderer/form-list-sort-field-render.component';
import * as moment from 'moment';
import { CommonDialogComponent, NrkDialogButton, NrkDialogType }
  from '../erp/shared/common-dialog/common-dialog.component';
import { DownloadType } from '../../@models/erp/baseProduct';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { SharedDataService } from '../../@core/service/shared-data.service';
import { mongoId, stableSort } from '../../@core/common/global';
import * as saveAs from 'file-saver';

@Component({
    selector: 'ngx-report',
    templateUrl: './activity.component.html',
    styleUrls: ['./activity.component.scss'],
    animations: [
        trigger('showAnimation', [
            transition(':enter', [
                style({ transform: 'translateY(-50%) scaleY(0)' }),
                animate('500ms', style({ transform: 'translateY(0) scaleY(1)' })),
            ]),
            transition(':leave', [
                style({ transform: 'translateY(0) scaleY(1)' }),
                animate('500ms', style({ transform: 'translateY(-50%) scaleY(0)' })),
            ]),
        ]),
    ]
})


export class ActivityComponent extends SidebarCommon<ActivityModel> implements OnInit, OnDestroy {
  ////////////////////////////////////////////////////////////////////////////
  // Properties

  // #region Properties
  // public companies: BusinessModel[];

  public isSaving = false;
  public activities: ActivityModel[];

  public ActivityContentType = EActivityContentType;

  protected activityStatusData = ActivityStatusData;
  protected activityStatus = EActivityStatus;


  // public business: Observable<BusinessModel[]>;
  // public businessUnits: Observable<BusinessUnitModel[]>;

  public search: string;

  public sort = { col: null, dir: 1 }

  public isPreview = false;
  public downloadType = DownloadType;

  public showPlanned;

  public visitReportColumns = {
    project: {
      title: 'Project',
      type: 'custom',
      renderComponent: FormListProjectRendererComponent,
      editor: {
        type: 'list',
        config: {
          selectedText: 'Select',
          list: [],
        },
      },
      filter: false,
    },
    topic: {
      title: 'Topic (60)',
      type: 'text',
      editor: {
        type: 'textarea',
      },
      filter: false,
    },
    action: {
      title: 'Action/Description (1000)',
      type: 'text',
      editor: {
        type: 'textarea',
      },
      filter: false,
    },
    plan: {
      title: 'Action plan',
      type: 'custom',
      renderComponent: FormListActionplanComponent,
      editor: {
        type: 'custom',
        component: FormListActionplanEditComponent,
      },
      filter: false,
    },
    sort: {
      title: 'Sort',
      type: 'custom',
      renderComponent: FormListSortFieldRenderComponent,
      onComponentInitFunction: (instance) => {},
      filter: false,
      editable: false,
      edit: null,
    },
  };

  JSON = JSON;

  newVersion = false;
  user: UserModel;

  showReportUI = false;

  showPreparedByOwnerOnly = true;

  reportFilter = {
    rsms: [],
    user: null,
    dateFrom: null,
    dateTo: null,
    xls: true,
    plannedActivityReport: 1,
    hideActivityByProject: true,
    overviewReport: true,
    showPreparedByOwnerOnly: false,
  }

  ////////////////////////////////////////////////////////////////////////////

  p: number = 1;

  saveOptions: {key: string, value: string}[] = [
    {key: 'P', value: 'Publish' },
    {key: 'H', value: 'Hide from Newsfeed'},
    {key: 'O', value: 'Private'},
  ];
  saveOptionValue: string;


  errorSubscription: Subscription;
  ////////////////////////////////////////////////////////////////////////////

  constructor(
    private api: ApiService,
    private auth: AuthGuardService,
    protected data: SharedDataService,
    private toastrService: NbToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: NbDialogService,
  ) {
    super();


    this.visitReportColumns.sort.onComponentInitFunction = (instance) => {

      instance.sortUp.subscribe(row => {
        const above = (this.selected.content as VisitReportContentModel).topics .find(x => x.sort === row.sort - 1)
        const actual = (this.selected.content as VisitReportContentModel).topics .find(x => x.sort === row.sort);
        if (above != null && actual != null) {
          above.sort = row.sort;
          actual.sort = row.sort - 1;
        }
        this.selected = JSON.parse(JSON.stringify(this.selected));
        // alert('UP! ' + row.sort);
      });
      instance.sortDown.subscribe(row => {
        const below = (this.selected.content as VisitReportContentModel).topics.find(x => x.sort === row.sort + 1)
        const actual = (this.selected.content as VisitReportContentModel).topics .find(x => x.sort === row.sort);
        if (below != null && actual != null) {
          below.sort = row.sort;
          actual.sort = row.sort + 1;
        }
        this.selected = JSON.parse(JSON.stringify(this.selected));
        // alert('DOWN! ');
      })
    }
    // this.companies = [];

    /* this.filterCustomerOptions = this.technicians.map((value: TechnicianModel) => {
      return { id: value.id, name: value.name.join(' ') };
    });

    this.filterLocationOptions = this.companies.map((value: BusinessModel) => {
      return { id: value.id, name: value.name.join(' ') };
    }); */

  }

  ////////////////////////////////////////////////////////////////////////////

public async ngOnInit() {

    await new Promise( res => this.auth.loadMe().then(async user => {
      this.user = user;
      res(user);
    }));

    this.loadActivities();

    //this.technicians = this.service.loadTechnnicians();
    this.errorSubscription = this.api.error.subscribe(x => {
      this.isSaving = false;
    })
  }

  ////////////////////////////////////////////////////////////////////////////

  private getActivityFilter() {
    return {
      $or: [{ 'participants.contact': this.user.contact }, { $expr: { $eq: [{ $toString: '$owner' }, mongoId(this.user)] } }]
    }
  }

  private activitiesSubscription: Subscription;

  private loadActivities() {
    this.activitiesSubscription = this.api.reloadActivities(true, this.getActivityFilter()).subscribe((activities) => {
      activities.forEach(a => {
        if (a.planned && !a.status) a.status = EActivityStatus.planned; // legacy TODO: remove planned in favour of status
      })
      this.activities = activities

      if (this.route.snapshot.queryParams.edit) {
        const item = activities.find(f => f._id === this.route.snapshot.queryParams.edit);
        this.toggleSidebar(item);
      } else if (this.route.snapshot.queryParams.newVersion) {
        const item = activities.find(f => f._id === this.route.snapshot.queryParams.newVersion);
        item.original = true;
        item.version +=1;
        item.draft = true;
        this.newVersion = true;
        this.toggleSidebar(item);
      }
      // remove query params
      this.router.navigate([], { queryParams: { edit: null, newVersion: null } });
    });
  }

  private refreshActivities() {
    this.api.reloadActivities(true, this.getActivityFilter());
  }

  ngOnDestroy(): void {
    if (this.activitiesSubscription) this.activitiesSubscription.unsubscribe()
    if (this.errorSubscription) this.errorSubscription.unsubscribe()
  }

  ////////////////////////////////////////////////////////////////////////////

  getActivityType(value: number): string {
    return EActivityContentType[value];
  }


  ////////////////////////////////////////////////////////////////////////////
  // Overrides

  toggleSidebar(item: ActivityModel) {

    if (item != null && item.business != null) {
      FormListActionplanEditComponent.businessId = item.business._id;
      this.visitReportColumns.project.editor.config.list = item.business.projects.filter(f => f.active).map(x => {
        return {title: x.name, value: x._id}
      });

      if (item.public && !item.hide) this.saveOptionValue = 'P';
      else if (item.hide) this.saveOptionValue = 'H';
      else this.saveOptionValue = 'O';
      // this.cancel(item)
    }
    // console.log(this.visitReportColumns);
    super.toggleSidebar(item);
  }



  public remove(item: ActivityModel) { // TODO!!
    // this.activities.splice(this.activities.indexOf(item), 1)
  }


  ////////////////////////////////////////////////////////////////////////////
  // FILTER

  /* public ApplyFilter(values: TechnicianModel[],
                     filterName: string[],
                     filterCompany: string[],
                     filterStatus: boolean[]): TechnicianModel[] {
    return values
      .filter((value: TechnicianModel) => {
        if (filterName == null || filterName.length === 0) return true;
        return filterName.filter((x) => x === value.id).length > 0;
      })
      .filter((value: TechnicianModel) => {
        if (filterCompany == null || filterCompany.length === 0) return true;
        return filterCompany.filter((x) => x === value.companyRef).length > 0;
      })
      .filter((value: TechnicianModel) => {
        if (filterStatus == null || filterStatus.length === 0) return true;
        return filterStatus.filter((x) => x  === value.active).length > 0;
      })
    ;
  } */

  public formatGroups(groups: string[]): string {
    return (groups || []).sort().map((x) => '<span class="badge badge-secondary">' + x + '</span>').join('<br>');
  }

  public saveVersion(item: ActivityModel) {
    // this.dialogService.open(DialogCommentComponent, {context: {
    //   message: item.version == null ? 'Document created' : '',
    // }})
    //   .onClose.subscribe(x => {
    //     if (x != null && x.length > 0) {
    //       item.comment = x;
    //       this.saveActivity(item, false);
    //     } else {
    //       this.toastrService.danger('Changes not saved!', 'Error');
    //     }
    //   });
    this.dialogService.open(CommonDialogComponent, {
      // closeOnBackdropClick: false,
      context: {
        dialogType: NrkDialogType.pdfSelection,
        attachOnly: !this.isNoteOrVRorOM(),
      },
    }).onClose.subscribe(async x => {
      if (x) {
        // const downloadType = x.button === NrkDialogButton.mergePdf ? DownloadType.merged : DownloadType.document;
        this.saveActivity(item, false, x.downloadType, !this.newVersion);
      } else {
        this.toastrService.danger('Changes not saved!', 'Error');
      }
    });
  }

  public saveDraft(item: ActivityModel) {
    this.saveActivity(item, true, DownloadType.document);
  }

  public async cancelDraft(item: ActivityModel) {
    if (item._id) await this.api.deleteActivity(item._id);
    this.refresh();
    this.hideSidebar();
  }

  private saveActivity(item: ActivityModel, draft: boolean, downloadType: DownloadType, edit: boolean = false) {
    // this.service.saveTechnicians(this.technicians);

    if (item.content.type === 0 && !item.project && this.selected && this.selected.business && this.selected.business.projects) {
      item.project = this.selected.business.projects.find(f => f.name.toLowerCase() === 'general');
    }

    if (item.project != null && (item.project as ProjectModel).name != null)
      item.project = (item.project as ProjectModel)._id;

    item.draft = draft;

    switch (this.saveOptionValue) {
      case 'P':
        item.public = true;
        item.hide = false;
        break;
      case 'H':
        item.public = true;
        item.hide = true;
        break;
      case 'O':
        item.public = false;
        item.hide = false;
        break;
    }
    ((item.content as VisitReportContentModel).topics || []).forEach(x => {
      if (x.sort === 0 || x.sort as unknown as string === '')
        x.sort = ((this.selected.content as VisitReportContentModel).topics || []).length;
    });

    if (item.business == null) this.toastrService.danger('Customer is required', 'Error');
    else if (item.content == null || item.content.type == null)
      this.toastrService.danger('Type needs to be selected', 'Error');
    else if (item.title == null || item.title.length === 0)
      this.toastrService.danger('Title is required', 'Error');
    else if (item.date == null || item.date.length === 0)
      this.toastrService.danger('Date is required', 'Error');
    else if (item.purpose == null || item.purpose.length === 0)
      this.toastrService.danger('Summary is required', 'Error');
    else if (item.title.length > 60)
      this.toastrService.danger('Title is limited to 60 characters', 'Error');
    else if ((item.location || '').length > 40)
      this.toastrService.danger('Location is limited to 40 characters', 'Error');
    else if (item.purpose.length > 400)
      this.toastrService.danger('Summary is limited to 400 characters', 'Error');
    else if ((item.content && item.content.type == 0) && item.project == null) {
      this.toastrService.danger('Project is required', 'Error');
    } else {
      this.isSaving = true;
      this.api.saveActivity(item, edit)
        .subscribe((i) => {
          if (downloadType && !item.draft && this.isNoteOrVRorOM()) this.api.downloadVisitReport(i, downloadType);
          this.toastrService.success(`Activity '${i.title}' saved!`, 'Success');
          this.selected = i;
          this.isSaving = false;
          if (!draft) this.hideSidebar();
        }, (err) => {
        });
      // item._id = item.versions[item.versions.length-1]._id || item.versions[item.versions.length-1] as any;
      // item.original = false;
      // item.versions = [];
      // this.api.saveActivity(item, true);
    }
  }

  pdfPreview(item: ActivityModel, downloadType: DownloadType) {
    if (downloadType === DownloadType.pdfAndZip) {
      this.api.downloadVisitReport(item, DownloadType.document);
      this.api.downloadVisitReport(item, DownloadType.zipAttachments);
    } else {
      this.api.downloadVisitReport(item, downloadType);
    }
  }

  public save(item: ActivityModel) {
    this.saveActivity(item, false, DownloadType.merged);
  }

  public cancel(item: ActivityModel) {
    this.toggleSidebar(item);
    // this.technicians = this.service.loadTechnnicians();
  }

  public getBusinessGeneral(business: BusinessModel): ContactModel {
    if (business == null || business.contacts == null) return null;
    return business.contacts.find(x => Number(x.type) === EContactType.General);
  }

  public editBusiness: BusinessModel;
  public editBusinessGeneral: ContactModel;

  public async openBusinessEdit() {
    this.editBusiness = null;
    this.editBusinessGeneral = null;
    const business = this.selected?.business;
    if (business == null) return;
    const all = this.data.businessesWithDisabled != null
      ? this.data.businessesWithDisabled
      : await this.data.loadBusinesses();
    this.editBusiness = all.find(b => b._id === (business as any)._id) || business;
    this.editBusinessGeneral = this.getBusinessGeneral(this.editBusiness);
  }

  public saveBusiness(item: BusinessModel) {
    if (item.manager != null && (item.manager as ContactModel).type != null) {
      item.manager = (item.manager as ContactModel)._id;
    }

    if (item.name == null || item.name.length === 0) {
      this.toastrService.danger('Name is required', 'Error');
      return;
    } else if (item.type == null) {
      this.toastrService.danger('Type is required', 'Error');
      return;
    }
    this.isSaving = true;
    this.api.saveBusiness(item)
      .subscribe((i) => {
        this.data.reloadBusinesses().then(b => {
          this.editBusiness = this.selected.business = b.find(c => c._id === i._id);
          this.editBusinessGeneral = this.getBusinessGeneral(this.editBusiness);
        });
        this.data.reloadContacts();
        this.refreshActivities();
        this.toastrService.success(`Business '${i.name}' update successful`, 'Saved');
        this.isSaving = false;
      });
  }

  public refresh(): void {
    this.api.reloadActivities();
  }

  ////////////////////////////////////////////////////////////////////////////

  create(planned = false) {
    super.create();
    this.selected.public = true;
    this.selected.owner = this.user;
    this.selected.version = 1;
    this.selected.draft = true;
    this.selected.planned = planned;
    this.selected.status = planned ? EActivityStatus.planned :  EActivityStatus.default;
    this.saveOptionValue = 'P';
  }

  generateVR(selected: ActivityModel): void {
    selected.content = new VisitReportContentModel();
    FormListActionplanEditComponent.businessId = this.selected.business._id;

    this.visitReportColumns.project.editor.config.list = selected.business.projects.filter(f => f.active).map(x => {
      return {title: x.name, value: x._id}
    });
  }

  generateQuickNote(selected: ActivityModel): void {
    selected.content = new EmptyActivityContentModel();
  }

  generateInvoice(selected: ActivityModel): void {
    selected.content = new InvoiceActivityContentModel();
  }

  generateOrder(selected: ActivityModel): void {
    selected.content = new OrderActivityContentModel();
  }
  generateOrderConfirmation(selected: ActivityModel) {
    selected.content = new OrderConfirmationActivityContentModel();
  }

  generateOffer(selected: ActivityModel) {
    selected.content = new OfferContentModel();
  }

  generateNote(selected: ActivityModel) {
    selected.content = new NoteContentModel();
    FormListActionplanEditComponent.businessId = this.selected.business._id;
    this.visitReportColumns.project.editor.config.list = selected.business.projects.filter(f => f.active).map(x => {
      return {title: x.name, value: x._id}
    });
  }

  generateOnlineMeeting(selected: ActivityModel) {
    selected.content = new OnlineMeetingContentModel();
    FormListActionplanEditComponent.businessId = this.selected.business._id;
    this.visitReportColumns.project.editor.config.list = selected.business.projects.filter(f => f.active).map(x => {
      return {title: x.name, value: x._id}
    });
  }

  generateTradeShowMeeting(selected: ActivityModel) {
    selected.content = new TradeShowMeetingContentModel();
    FormListActionplanEditComponent.businessId = this.selected.business._id;
    this.visitReportColumns.project.editor.config.list = selected.business.projects.filter(f => f.active).map(x => {
      return {title: x.name, value: x._id}
    });
  }

  generateOnSiteMeeting(selected: ActivityModel) {
    selected.content = new OnSiteMeetingContentModel();
    FormListActionplanEditComponent.businessId = this.selected.business._id;
    this.visitReportColumns.project.editor.config.list = selected.business.projects.filter(f => f.active).map(x => {
      return {title: x.name, value: x._id}
    });
  }

  generateProjectSummary(selected: ActivityModel) {
    selected.content = new ProjectSummaryContentModel();
    FormListActionplanEditComponent.businessId = this.selected.business._id;
    this.visitReportColumns.project.editor.config.list = selected.business.projects.filter(f => f.active).map(x => {
      return {title: x.name, value: x._id}
    });
  }

  changeVR(selected: ActivityModel, event: TopicModel[]) {
    const vr = selected.content as VisitReportContentModel;
    vr.topics = event.sort((a, b) => a.sort - b.sort);
  }

  ////////////////////////////////////////////////////////////////////////////

  validateVR(event) {
    if (FormListActionplanEditComponent.instance.isDirty() &&
      !FormListActionplanEditComponent.instance.addParticipant())
      event.confirm.reject('Action plan invalid');

    if (event.newData.project === '') {
      event.confirm.reject('Project is required');
      this.toastrService.danger('Project is required', 'Error');
    } else if (event.newData.businessUnit === '') {
      event.confirm.reject('BusinessUnit is required');
      this.toastrService.danger('BusinessUnit is required', 'Error');
    } else if (event.newData.action === '') {
      event.confirm.reject();
      this.toastrService.danger('Action / Description is required', 'Error')
    } else if (event.newData.topic.length > 60) {
      event.confirm.reject();
      this.toastrService.danger('Topic is limited to 60 characters', 'Error')
    } else if (event.newData.action.length > 1000) {
      event.confirm.reject();
      this.toastrService.danger('Action / Description is limited to 1000 characters', 'Error')
    /* } else if (event.newData.plan.length > 200) {
      event.confirm.reject();
      this.toastrService.danger('Action plan is limited to 200 characters', 'Error')*/
    } else {


      event.confirm.resolve();


      if (!this.selected.planned) setTimeout(() => {
        if (this.selected.draft) {
          this.saveDraft(this.selected);
        } else {
          this.saveActivity(this.selected, false, null, true);
        }
      }, 0);


    }

  }

  isNoteOrVRorOM(item: ActivityModel = null) {
    if (!item) item = this.selected;
    return item && item.content
      && (item.content.type === EActivityContentType.VisitReport
        || item.content.type === EActivityContentType.Note
        || item.content.type === EActivityContentType.OnlineMeeting
        || item.content.type === EActivityContentType.TradeShowMeeting
        || item.content.type === EActivityContentType.OnSiteMeeting
        )
  }


  /* selectProject(item: CompleterItem) {
    if (item != null)
      this.selected.project = item.originalObject;
    else this.selected.project = null;
  } */

  /* public populateParticipants(activity: ActivityModel): Observable<UserModel[]> {

    return activity.participantIds.map(x => this.service.populateUser(x));
  } */


  /*
  onDeleteConfirm(event): void {
    if (window.confirm('Are you sure you want to delete?')) {
      event.confirm.resolve();
    } else {
      event.confirm.reject();
    }
  }*/


  //
  showNews(activity: string) {
    this.router.navigate(['pages', 'news', activity], {queryParams: {back: 'pages/activity'}});

  }


  filter(search: string, activities: ActivityModel[]) {

    if (!activities) return [];

    if (this.showPlanned) {
      activities = activities.filter(f => this.showPlanned === 1 ? f.planned : !f.planned);
    }

    if (this.showPreparedByOwnerOnly) {
      activities = activities.filter(f => mongoId(f.owner) === mongoId(this.user));
    }

    activities = activities.filter( f => 
      this.reportFilter.dateFrom && this.reportFilter.dateTo
        ? f.date > this.reportFilter.dateFrom && f.date < this.reportFilter.dateTo
        : this.reportFilter.dateFrom && !this.reportFilter.dateTo
          ? f.date > this.reportFilter.dateFrom
          : !this.reportFilter.dateFrom && this.reportFilter.dateTo
            ? f.date < this.reportFilter.dateTo
            : true
    )

    let ret = activities;

    if ((search == null || search.length === 0) && this.sort.col === null) return ret;

    if (search != null && search.length !== 0) {
      const s = search.toLowerCase();
      ret = activities.filter(x =>
        (x.location || '').toLowerCase().includes(s) ||
        (x.purpose || '').toLowerCase().includes(s) ||
        (x.business.name || '').toLowerCase().includes(s) ||
        (x.title || '').toLowerCase().includes(s) ||
        (this.getVersionCode(x) || '').toLowerCase().includes(s)
      )
    }

    if (this.sort.col) {
      switch (this.sort.col) {
        case 'type':
          ret = stableSort(ret, [(b) => b.content?.[this.sort.col]], [this.sort.dir], []);
          break;
        case 'name':
          ret = stableSort(ret, [(b) => b.business?.[this.sort.col]], [this.sort.dir], []);
          break;
        default: 
          ret = stableSort(ret, [(b) => b[this.sort.col]], [this.sort.dir], []);
          break;
      }
    }

    return ret;
  }

  getVersionCode(item: ActivityModel) {
    const date = moment(item.date).utc().format('YYMMDD');
    const company = 'NRKA'; // item.business.name;
    const name = item.owner.short;
    const seq = (item.seq || 0).toString().padStart(4, '0');
    const v = ((item.version || 0) /* + (item.draft ? 1 : 0) */).toString().padStart(2, '0');
    const type = ActivityContentModel.getShort(item.content.type);
    return `${type}${name}${company}${seq}-VS${v}${item.draft ? '-DRAFT' : ''}`;
  }

  async openVR(item: ActivityModel) {
    return await this.api.downloadVisitReport(item || this.selected);
    /* this.api.downloadVisitReport(_id).subscribe(data => {
      const company = 'NRKA'; // item.business.name;
      const short = this.selected.owner.short;
      const vs = this.selected.version.toString().padStart(2, '0');

      const name = `VR${short}${company}${this.selected.seq.toString().padStart(4, '0')}-VS${vs}`;

      saveAs(data, name);
    }) */
  }

  showMergeOrZipButton() {
    return this.selected && this.selected.pdfs && this.selected.pdfs.filter(f => f.checked)
  }

  revert() {
    if (this.selected.versions == null || this.selected.versions.length === 0) return;
    const versions = this.selected.versions
      .filter(x => x.original === false && x.draft === false)
      .sort((a, b) => b.version - a.version );
    if (versions == null || versions.length === 0) return;
    const version = versions[0];
    this.selected.title = version.title;
    this.selected.location = version.location;
    this.selected.date = version.date;
    this.selected.purpose = version.purpose;
    this.selected.participants = version.participants;
    this.selected.files = version.files;
    this.selected.pdfs = version.pdfs;
    this.selected.content = version.content;
    this.selected.project = version.project;
  }


  turnIntoActivity(testIf = false) {

    if (testIf) {
      return this.selected.planned && this.selected.date && new Date(this.selected.date) < new Date();
    }

    this.selected.planned = false;
    this.selected.status = EActivityStatus.default;
    this.save(this.selected);

  }

  async setItemStatus(item:ActivityModel, status: EActivityStatus) {

    const activity = await firstValueFrom(this.api.loadActivity(mongoId(item)));
    if (item.status === EActivityStatus.planned) {
      this.dialogService.open(CommonDialogComponent, {
        context: {
          dialogType: NrkDialogType.revise,
          message: 'Enter a reason for cancellation:',
          okText: 'Cancel Activity',
          cancelText: 'Abort',
        },
      }).onClose.subscribe(async x => {
        if (x && x.button === NrkDialogButton.save && x.text.length) {
          activity.cancelReason = item.cancelReason = x.text;
          activity.status = item.status = status;
          this.api.saveActivity(activity);
        }
      });
    } else {
      activity.status = item.status = status;
      this.api.saveActivity(activity);
    }
  }


  downloadReport(xls = false, planned = 0) {
    this.reportFilter = {
      rsms: [mongoId(this.user.contact)],
      user: mongoId(this.user),
      dateFrom: this.reportFilter.dateFrom,
      dateTo: this.reportFilter.dateTo,
      xls: xls,
      plannedActivityReport: planned,
      hideActivityByProject: true,
      overviewReport: true,
      showPreparedByOwnerOnly: this.showPreparedByOwnerOnly,
    }
    console.log('report filter', this.reportFilter);
    this.api.downloadSalesReport(this.reportFilter as any).subscribe(data => {
      const currDate = moment().format('YYMMDD');
      const fromDate = this.reportFilter.dateFrom ? '_' + moment(this.reportFilter.dateFrom).format('YYMMDD') : ''
      const toDate = this.reportFilter.dateTo ? '_' + moment(this.reportFilter.dateTo).format('YYMMDD') : ''
      let filename = `${currDate}_${this.auth.user.short}_allactivity${fromDate}${toDate}`;
      if (planned === 1) filename = `${currDate}_${this.auth.user.short}_plannedactivity${fromDate}${toDate}`;
      if (planned === 2) filename = `${currDate}_${this.auth.user.short}_completedactivity${fromDate}${toDate}`;
      if (xls) {
        filename += '.xls';
      } else {
        filename += '.pdf';
      }
      saveAs(data, filename);
    });

  }

}
